import React from "react";
import { BaseComponent } from "BaseComponent";
import { connect } from "react-redux";
import { Field, reduxForm, reset } from "redux-form";
import { sendMessage, openContactUsModal } from "CheckoutAction";
import { Modal } from "react-bootstrap";
import Button from "react-bootstrap-button-loader";
import {
  BASE_IMAGES_URL,
  ACCESS_FILES_API_KEY,
  COMMON_FAIL_MESSAGE,
} from "Constants";
import { showError, showSuccess } from "ReduxErrorBar";
import { trimValue } from "BaseComponent";
import draftToHtml from "draftjs-to-html";

class ContactUs extends BaseComponent {
  constructor(props) {
    super(props);
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
    this.state = { loading: false, active: false };
  }

  open() {
    this.props.reset();
    this.setState({ ...this.state, loading: false });
    this.props.openContactUsModal(true);
  }

  close() {
    this.props.openContactUsModal(false);
    this.setState({ active: false, loading: false });
  }

  onFormSubmit(values) {
    //debugger;
    var data;
    if (values.message && values.message.blocks) {
      var html = draftToHtml(values.message);
      html = html.replace(/[\n\r]+/g, "");
      if (html == "<p></p>") html = "";
      data = { ...values, message: html };
    } else data = { ...values };

    this.setState({ loading: true });

    this.props.sendMessage(this.props.session, data, (result) => {
      if (result.success === 1) {
        this.props.reset();
        this.close();
        this.props.showSuccess("Message sent successfully!");
      } else {
        this.props.showError(COMMON_FAIL_MESSAGE);
      }
      this.setState({ loading: false });
    });
  }

  render() {
    var { handleSubmit, pristine, dirty, reset, submitting, valid } =
      this.props;

    var disabled = !((dirty && valid) || (pristine && this.state.active));

    return (
      <Modal
        className="modal-container"
        show={this.props.showModal === true ? true : false}
        onHide={this.close}
        animation={true}
        keyboard={false}
        backdrop="static"
      >
        <form
          onSubmit={handleSubmit(this.onFormSubmit.bind(this))}
          encType="multipart/form-data"
        >
          <Modal.Body style={{ height: 350 }}>
            <div className="import-header">
              <div className="import-modal-title">Contact Us</div>
              <button
                type="button"
                className="close btn-sm btn-close "
                onClick={() => this.close()}
                style={{ marginTop: -25 }}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="basicform" style={{ padding: 20 }}>
              <Field
                name="email"
                label="Email ID"
                placeholder="Enter your emailid"
                type="email"
                component={this.renderFieldText}
                mandatory="true"
              />
              <Field
                name="message"
                label="Message"
                placeholder="How can we help you?"
                component={this.renderRichTextareaWithLabel}
                mandatory="true"
                type="minimal"
              />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button className="button-theme" onClick={this.close}>
              Close
            </Button>
            <Button
              className="button-theme button-theme-blue"
              bsStyle="primary"
              type="submit"
              loading={this.state.loading}
              disabled={disabled}
            >
              Send
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    );
  }
}

function validate(values) {
  var errors = {};

  var requiredFields = ["email", "message"];
  requiredFields.forEach((field) => {
    if (!values[field]) {
      errors[field] = "Required";
    }
  });
  var newscontent;
  if (values.message) {
    if (values.message.blocks) newscontent = draftToHtml(values.message);
    else newscontent = values.message;

    newscontent = newscontent.replace(/[\n\r]+/g, "");
  }
  if (values.message && newscontent === "<p></p>") {
    errors.message = "Required";
  }
  return errors;
}

function mapStateToProps(state) {
  return {
    session: state.session,
    showModal: state.contactUsModal,
  };
}

export default connect(mapStateToProps, {
  sendMessage,
  showError,
  showSuccess,
  openContactUsModal,
})(
  reduxForm({
    validate,
    form: "ContactUsForm",
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
  })(ContactUs)
);
